import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { ContentService } from '../../services/content/content.service';
import * as _ from 'lodash';

@Pipe({
  name: 'contentInformation'
})
export class AlphabetPipe implements PipeTransform {

  constructor(private cm: ContentService) {
  }

  transform(entry: Models.ContentEntry): Models.AlphabetEntry | Models.InformationEntry {

    if (!entry || !entry.related) {
      const contentEntry = this.cm.getEntry(entry._id);
      return this.getAlphabetEntry(entry, contentEntry);
    }

    const alphabetEntry = new Models.AlphabetEntry();
    const goodToKnowEntries: Models.InformationEntry[] = [];

    const alphabeticalEntries = {};
    const alphabetEntries: Models.AlphabetContentGroupEntry[] = [];

    if (entry.related.entries) {
      for (const item of entry.related.entries) {
        const contentEntry = this.cm.getEntry(item.id);

        let informationEntry = this.getAlphabetEntry(item, contentEntry);

        let key = '#';
        if (/^[a-zA-ZäöüÄÖÜÉÈÀàéè()]+$/.test(informationEntry.title.charAt(0))) {
          if (/^[äöüÄÖÜÉÈÀàéè()]+$/.test(informationEntry.title.charAt(0))) {
            let secondKey = 'a';
            if (/^[ÉÈàéè()]+$/.test(informationEntry.title.charAt(0))) {
              secondKey = 'e';
            }
            if (/^[Öö()]+$/.test(informationEntry.title.charAt(0))) {
              secondKey = 'o';
            }
            if (/^[Üü()]+$/.test(informationEntry.title.charAt(0))) {
              secondKey = 'u';
            }
            if (!alphabeticalEntries[secondKey]) {
              alphabeticalEntries[secondKey] = [informationEntry];
            } else {
              alphabeticalEntries[secondKey].push(informationEntry);
            }
          } else {
            key = informationEntry.title.charAt(0).toLowerCase();
          }
        }
        if (!alphabeticalEntries[key]) {
          alphabeticalEntries[key] = [informationEntry];
        } else {
          alphabeticalEntries[key].push(informationEntry);
        }

        if (contentEntry.detail.goodToKnow === 1) {
          goodToKnowEntries.push(informationEntry);
        }
      }
    }

    const a = 97;
    for (let i = 0; i < 26; i++) {
      const key = String.fromCharCode(a + i);
      if (!alphabeticalEntries[key]) {
        continue;
      }
      const alphabetGroupEntry = new Models.AlphabetContentGroupEntry();
      alphabetGroupEntry.populateFromJSON({ key, entries: _.orderBy(alphabeticalEntries[key], ['title']) });
      alphabetEntries.push(alphabetGroupEntry);
    }

    if (alphabeticalEntries['#']) {
      const alphabetGroupEntry = new Models.AlphabetContentGroupEntry();
      alphabetGroupEntry.populateFromJSON({ key: '#', entries: _.orderBy(alphabeticalEntries['#'], ['title']) });
      alphabetEntries.push(alphabetGroupEntry);
    }

    if (alphabetEntries.length === 0) {
      return null;
    }

    alphabetEntry.populateFromJSON({
      sourceId: entry._id,
      goodToKnowEntries: _.orderBy(goodToKnowEntries, ['title']),
      alphabetEntries
    });

    return alphabetEntry;
  }

  private getAlphabetEntry(item, contentEntry): Models.InformationEntry {

    if (!contentEntry) {
      return null;
    }

    const informationEntry = new Models.InformationEntry();
    informationEntry.populateFromJSON({
      sourceId: item.id || item._id,
      title: contentEntry.title,
      description: contentEntry.detail.description,
      media: this.cm.getMediaEntriesForEntry(item.id || item._id),
      documents: this.cm.getDocumentEntriesForEntry(item.id || item._id)
    });
    return informationEntry;
  }
}
